require('es6-promise').polyfill()
require('babel-polyfill')

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, IndexRoute, Redirect, browserHistory } from 'react-router'
import { createStore } from '@dr-kobros/react-broilerplate/lib/redux'
import { createApp } from '@dr-kobros/react-broilerplate/lib/app'
import * as reducers from './ducks/index'

import AppContainer from './components/smart/AppContainer'
import TranslationInitContainer from './components/smart/TranslationInitContainer'
import WopiQuestionnaireContainer from './components/smart/WopiQuestionnaireContainer'
import WopiListContainer from './components/smart/WopiListContainer'
import GroupDriversComparisonContainer from './components/smart/GroupDriversComparisonContainer'
import WopiInvitationContainer from './components/smart/WopiInvitationContainer'
import LoggedInContainer from './components/smart/LoggedInContainer'
import LoginContainer from './components/smart/LoginContainer'
import AccountContainer from './components/smart/AccountContainer'
import TranslationsContainer from './components/smart/TranslationsContainer'
import AccountListContainer from './components/smart/AccountListContainer'
import OrganisationCreationContainer from './components/smart/OrganisationCreationContainer'
import OrganisationListContainer from './components/smart/OrganisationListContainer'
import OrganisationEditContainer from './components/smart/OrganisationEditContainer'
import AccountCreationContainer from './components/smart/AccountCreationContainer'
import AccountVerificationContainer from './components/smart/AccountVerificationContainer'
import UsageLogContainer from './components/smart/UsageLogContainer'
import OrganisationAccountCreationContainer from './components/smart/OrganisationAccountCreationContainer'
import OrganisationAccountListContainer from './components/smart/OrganisationAccountListContainer'
import OrganisationUsageLogContainer from './components/smart/OrganisationUsageLogContainer'
import ForgotPasswordContainer from './components/smart/ForgotPasswordContainer'
import ResetPasswordContainer from './components/smart/ResetPasswordContainer'
import SupportPageContainer from './components/smart/SupportPageContainer'
import Wopi360QuestionnaireContainer from './components/smart/Wopi360QuestionnaireContainer'
import Wopi360TargetListContainer from './components/smart/Wopi360TargetListContainer'
import Wopi360TargetCreateContainer from './components/smart/Wopi360TargetCreateContainer'
import Wopi360TargetEditContainer from './components/smart/Wopi360TargetEditContainer'
import Wopi360TargetDetailsContainer from './components/smart/Wopi360TargetDetailsContainer'
import AnonWopi360TargetDetailsContainer from './components/smart/AnonWopi360TargetDetailsContainer'
import NotFound from './components/NotFound'
import {
  MainSubNavigation,
  SuperAdminSubNavigation,
  OrganisationAdminSubNavigation
} from './components/SubNavigation'
import App from './components/App'
import DefaultLanguageContainer from './components/smart/DefaultLanguageContainer'
import GroupRolesContainer from './components/smart/GroupRolesContainer'
import UnitListContainer from './components/smart/UnitListContainer'
import UnitCreateContainer from './components/smart/UnitCreateContainer'
import UnitEditContainer from './components/smart/UnitEditContainer'
import UnitDetailsContainer from './components/smart/UnitDetailsContainer'
import OrganisationData from './components/OrganisationData'

const { store, history } = createStore(
  reducers,
  browserHistory,
  [],
  window.__REDUX_DEVTOOLS_EXTENSION__ ? [window.__REDUX_DEVTOOLS_EXTENSION__()] : []
)

const router = (
  <Router history={history}>
    <Route path="/" component={TranslationInitContainer}>
      <Route component={LoggedInContainer}>
        <Route component={MainSubNavigation}>
          <IndexRoute component={WopiListContainer} />
          <Route path="new-test" component={WopiInvitationContainer} />
          <Route path="group-drivers" component={GroupDriversComparisonContainer} />
          <Route path="group-roles" component={GroupRolesContainer} />

          <Route path="wopi360" component={Wopi360TargetListContainer} />
          <Route path="new-target" component={Wopi360TargetCreateContainer} />
          <Route path="target/:uuid/details" component={Wopi360TargetDetailsContainer} />
          <Route path="target/:uuid/edit" component={Wopi360TargetEditContainer} />

          <Route path="units">
            <IndexRoute component={UnitListContainer} />
            <Route path="new" component={UnitCreateContainer} />
            <Route path="edit/:uuid" component={UnitEditContainer} />
            <Route path=":uuid" component={UnitDetailsContainer} />
          </Route>
        </Route>

        <Route path="profile" component={AccountContainer} />

        <Route path="management" component={OrganisationAdminSubNavigation}>
          <IndexRoute component={OrganisationAccountListContainer} />
          <Route path="accounts/new" component={OrganisationAccountCreationContainer} />
          <Route path="log" component={OrganisationUsageLogContainer} />
          <Route path="data" component={OrganisationData} />
        </Route>

        <Route path="admin" component={SuperAdminSubNavigation}>
          <Route path="accounts">
            <IndexRoute component={AccountListContainer} />
            <Route path="new" component={AccountCreationContainer} />
            <Route path="log" component={AccountCreationContainer} />
          </Route>
          <Route path="organisations">
            <IndexRoute component={OrganisationListContainer} />
            <Route path="new" component={OrganisationCreationContainer} />
            <Route path="edit/:id" component={OrganisationEditContainer} />
          </Route>
          <Route path="translations" component={TranslationsContainer} />
          <Route path="invoicing" component={UsageLogContainer} />
        </Route>

        <Route path="profile" component={AccountContainer} />

        <Route path="support" component={SupportPageContainer} />
      </Route>

      <Route component={AppContainer}>
        <Redirect from="q/:uuid" to="wopi/:uuid" />
        <Route path="wopi/:uuid" component={WopiQuestionnaireContainer} />
        <Route path="wopi360/:uuid" component={Wopi360QuestionnaireContainer} />
        <Route path="wopi360target/:uuid/details" component={AnonWopi360TargetDetailsContainer} />
      </Route>

      <Route component={AppContainer}>
        <Route component={App}>
          <Route component={DefaultLanguageContainer}>
            <Route path="login" component={LoginContainer} />
            <Route path="verify/:uuid" component={AccountVerificationContainer} />
            <Route path="forgot-password(/:state)" component={ForgotPasswordContainer} />
            <Route path="reset-password/:token" component={ResetPasswordContainer} />
            <Route path="*" component={NotFound} />
          </Route>
        </Route>
      </Route>
    </Route>
  </Router>
)

ReactDOM.render(createApp(store, history, router), document.getElementById('app'))



// WEBPACK FOOTER //
// ./src/app.js